import * as React from "react";

const Bill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="green"
    viewBox="0 0 24 24"
  >
    <path d="M14.324 11.387c-.547-1.272-2.073-2.124-3.41-1.901-1.337.222-1.979 1.433-1.432 2.706.578 1.343 2.234 2.202 3.598 1.863 1.209-.299 1.766-1.456 1.244-2.668zm-1.683 1.584l.12.267-.253.052-.113-.254c-.262.047-.561.041-.836-.031l-.076-.451c.227.035.509.067.725.023l.145-.047c.258-.126.179-.449-.204-.525-.284-.063-1.038-.017-1.319-.642-.158-.353-.041-.722.414-.891l-.125-.278.252-.052.12.266c.185-.031.401-.042.655-.02l.102.446c-.197-.025-.41-.047-.596-.009l-.07.018c-.359.095-.244.436.075.519.527.122 1.156.161 1.404.712.199.445-.034.75-.42.897zm7.198-7.971c-6.829 4.423-14.376-.351-19.839 4.92l4.161 9.08c5.854-4.962 13.835-.264 19.839-4.92l-4.161-9.08zm-12.843 10.475c-.815-.511-2.002-.838-2.875-.762l-1.189-2.597c.567-.608 1.021-1.684 1.169-2.655.185-.059.371-.117.566-.165 3.358-.833 7.543.079 11.852-.99.312-.077.609-.174.908-.269.678.475 1.511.809 2.302.923l1.316 2.871c-.532.673-.912 1.483-1.105 2.327-3.865 1.048-8.549-.094-12.944 1.317z" />
  </svg>
);

export default Bill;
